export const GetQRResourcesEN: GetQRResourcesInterface = {
  title: "Application point name",
  subtitle: "Planned tasks",
  buttons: {
    popuni: "Fill",
    pregled: "Preview",
    primjedbe: "Comments",
  },
  errors: {
    noinput:
      "Required fields are not entered. Please contact the administrator.",
    errorQuery:
      "An error occurred while collecting data. Please contact the administrator.",
    recordPointNotFound: {
      title: "Record point not found",
      message: "The requested record point was not found in the system.",
      suggestion: "Please contact the administrator for assistance.",
      icon: "mdi mdi-alert-circle-outline",
    },
    privateAccess: {
      title: "Private Record Point",
      message:
        "This record point is private and available only to authorized users. Login is required to access this data.",
      suggestion:
        "Please contact the administrator for access or log in to the system.",
      icon: "mdi mdi-lock-outline",
      mobileMessage: "This record point is private. Login required for access.",
      mobileSuggestion: "Contact administrator for access.",
    },
  },
  noItems: {
    title: "No evidence available",
    message: "No evidence is available for the selected period and criteria.",
    suggestion: "Please check the date range or contact the administrator.",
  },
  noActiveRecords: {
    title: "No active evidence",
    message:
      "For the scanned application point, there are no active evidence records that need to be filled out.",
    suggestion:
      "The evidence has already been filled out for the selected period. Please check the date range or contact the administrator.",
  },
  noRecordPoints: {
    message:
      "Currently there are no record points for the selected period. Please select a different date range.",
  },
  inputFields: {
    endDate: {
      label: "End date",
    },
    startDate: {
      label: "Start date",
    },
  },
  poljaEvidencije: {
    CIPP_V1: "Cleaning and washing premises",
    CIPO_V1: "Cleaning and washing equipment",
    Dezinfekcija_V1: "Disinfection",
    Dezinsekcija_V1: "Pest control",
    Deratizacija_V1: "Rodent control",
    Dezinsekcija_Kontrola_V1: "Pest control Control",
    Dezinskecija_Korekcija_V1: "Pest control Correction",
    Deratizacija_Kontrole_V1: "Rodent control Control",
    Deratizacija_Korekcije_V1: "Rodent control Correction",
    DezSr_V1: "Disinfection products",
    Dobavljac_V1: "Suppliers",
    Dostava_V1: "Delivery",
    EduZap_V1: "Employee education",
    Mol_V1: "Painting work",
    Oprema_V1: "Equipment",
    Otpad_V1: "Waste",
    PrijemRobe_V1: "Goods receipt",
    San_V1: "Sanitary inspection",
    Temperatura_V1: "Temperature lists",
    TemperaturaOgranicena_V1: "Temperature lists - limited",
    TemperaturaOgranicenaKKT_V1: "Temperature lists - limited - KKT",
    TemperaturaKKTProizvodiEvd_V1: "Temperature lists - products - KKT",
    CheckListEvd_V1: "Checklist",
  },
};

export interface GetQRResourcesInterface {
  title: string;
  subtitle: string;
  buttons: {
    popuni: string;
    pregled: string;
    primjedbe: string;
  };
  errors: {
    noinput: string;
    errorQuery: string;
    recordPointNotFound: {
      title: string;
      message: string;
      suggestion: string;
      icon: string;
    };
    privateAccess: {
      title: string;
      message: string;
      suggestion: string;
      icon: string;
      mobileMessage: string;
      mobileSuggestion: string;
    };
  };
  noItems: {
    title: string;
    message: string;
    suggestion: string;
  };
  noActiveRecords: {
    title: string;
    message: string;
    suggestion: string;
  };
  noRecordPoints: {
    message: string;
  };
  inputFields: {
    startDate: {
      label: string;
    };
    endDate: {
      label: string;
    };
  };
  poljaEvidencije: {
    CIPP_V1: string;
    CIPO_V1: string;
    Dezinfekcija_V1: string;
    Dezinsekcija_V1: string;
    Deratizacija_V1: string;
    Dezinsekcija_Kontrola_V1: string;
    Dezinskecija_Korekcija_V1: string;
    Deratizacija_Kontrole_V1: string;
    Deratizacija_Korekcije_V1: string;
    DezSr_V1: string;
    Dobavljac_V1: string;
    Dostava_V1: string;
    EduZap_V1: string;
    Mol_V1: string;
    Oprema_V1: string;
    Otpad_V1: string;
    PrijemRobe_V1: string;
    San_V1: string;
    Temperatura_V1: string;
    TemperaturaOgranicena_V1: string;
    TemperaturaOgranicenaKKT_V1: string;
    TemperaturaKKTProizvodiEvd_V1: string;
    CheckListEvd_V1: string;
  };
}

// http://localhost:3000/getqr?rtc=58&name=Dvoriste
